import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Editor as DraftJs } from "draft-js";

import PrimaryImagePopover from "editor/components/PrimaryImagePopover";
import Button from "components/library/Button";
import { saveForm } from "editor/actions/status";
import { updateFormAt, updateEditor } from "editor/actions/form";
import { IMAGE_CAPTION_PLACEHOLDER } from "config/constants/editor";
import { HANDLED, inlineHandlePastedText } from "editor/actions/editor";
import keyBindingFn from "editor/utils/keyBindingFn";
import { IMAGE_ROUTES } from "config/constants";

import styles from "./PrimaryImage.css";
import "draft-js/dist/Draft.css";

class PrimaryImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
      imageElement: null,
    };

    this.activateImageEditor = this._activateImageEditor.bind(this);
    this.removePrimaryImage = this._removePrimaryImage.bind(this);
    this.togglePopover = this._togglePopover.bind(this);
    this.onChange = this._onChange.bind(this);
  }

  _onChange(value) {
    return this.props.updateEditor(`${this.props.formPath}.caption`, true)(
      value
    );
  }

  _activateImageEditor() {
    return this.props.saveForm().then(() => {
      this.props.history.replace(this.props.getBaseUrl()); // add ID if article hasn't been saved yet
      this.props.history.push(
        this.props.getBaseUrl() + this.props.imageEditorPath
      );
    });
  }

  _removePrimaryImage() {
    this.props.updateFormAt(this.props.formPath, null);
  }

  _togglePopover() {
    this.setState({ isActive: !this.state.isActive });
  }

  render() {
    const hasImage =
      this.props.primaryImage &&
      Object.keys(this.props.primaryImage) &&
      "crops" in this.props.primaryImage;

    let button = null;
    if (!hasImage) {
      button = (
        <Button
          className={styles.button}
          data-cy="featureImageButton"
          isDisabled={this.props.status.isReadOnly}
          onClick={this.activateImageEditor}
          role="link"
          type="secondary"
        >
          Add a featured image
        </Button>
      );
    }

    return (
      <div
        className={classNames(
          styles.root,
          hasImage ? styles.hasImage : styles.noImage
        )}
      >
        {button}
        {hasImage ? (
          <figure className={styles.figure}>
            <div className={styles.placeholder}>
              <div
                className={classNames(styles.imageWrapper, {
                  [styles.isActive]: this.state.isActive,
                })}
                ref={element => {
                  if (!this.state.imageElement) {
                    this.setState({ imageElement: element });
                  }
                }}
                onClick={this.togglePopover}
              >
                <PrimaryImagePopover
                  closeModal={this.togglePopover}
                  imageElement={this.state.imageElement}
                  isActive={this.state.isActive}
                  removePrimaryImage={this.removePrimaryImage}
                />
                <img
                  className={styles.img}
                  src={this.props.primaryImage.crops["16x9"].url}
                  alt={this.props.primaryImage.alt_text}
                />
              </div>
            </div>
            <figcaption className={styles.primaryImageCaption}>
              <DraftJs
                editorState={this.props.primaryImage.caption}
                keyBindingFn={keyBindingFn}
                handleKeyCommand={this.props.handleKeyCommand}
                onChange={this.onChange}
                onBlur={this.props.saveForm}
                handleReturn={() => HANDLED}
                placeholder={IMAGE_CAPTION_PLACEHOLDER}
                handlePastedText={this.props.inlineHandlePastedText}
                readOnly={this.props.status.isReadOnly}
              />
            </figcaption>
          </figure>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    status: state.editor.status,
  };
};

const mapDispatchToProps = {
  saveForm,
  updateFormAt,
  updateEditor,
  inlineHandlePastedText,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PrimaryImage)
);

PrimaryImage.defaultProps = {
  imageEditorPath: `${IMAGE_ROUTES.PRIMARY}`,
};

PrimaryImage.propTypes = {
  getBaseUrl: PropTypes.func.isRequired,
  history: PropTypes.object,
  match: PropTypes.object,
  status: PropTypes.object.isRequired,
  primaryImage: PropTypes.object,
  imageEditorPath: PropTypes.string.isRequired,
  formPath: PropTypes.string.isRequired,
  inlineHandlePastedText: PropTypes.func.isRequired,
  handleKeyCommand: PropTypes.func,
};
